export default __webpack_public_path__ + "static/media/undraw_shopping.2f91ebbd.svg";